module.exports = __webpack_public_path__ + "static/media/aladdin.f693b0fa.gif";